export const CUSTOMER_REVIEWS_ID = 'customer-reviews';
